import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {  fetchProductsStart } from './../redux/Products/products.actions';
import { Form } from 'react-bootstrap'
import {Link} from 'react-router-dom'
import DashAuthWrapper from './../components/DashAuthWrapper'
import Button from './../components/forms/Button'


const mapState2 = ({ user, productsData }) => ({
	currentUser: user.currentUser,
	products: productsData.products,
})


const NeededServiceDetails = props => {
	const history = useHistory();
	const { currentUser,products } = useSelector(mapState2);
  	const dispatch = useDispatch();

	const { data } = products;

	useEffect(() => {
	window.scrollTo(0, 0)
	}, [])

	useEffect(() => {
	dispatch(
		fetchProductsStart()
	);
	// eslint-disable-next-line
	}, []);

	

	//create and filter array
	const payPerServiceArray = [];
	if(Array.isArray(data)){
		for(let i = 0; i < data.length; i++){
			if(data[i].productCategory === "Vendor Pay-Per Service"){
				payPerServiceArray.push(data[i]);
			}
		}
		
	}

		
	const congfigAuthWrapper = {
		headline: 'What service do you need?'
	}

	// console.log(payPerServiceArray)
	
	
	return (
		<div>
			
 			{!currentUser.subscribed &&(
				<DashAuthWrapper>
					<h3 className="mt-5">You currently have no subscription</h3>
				
					<h3>Please 
						<Link to="/services">
							<Button>
								SUBSCRIBE
							</Button>
						</Link>
						to be eligible for services
					</h3>
				</DashAuthWrapper>
			)}

			{currentUser.subscribed &&(
				<DashAuthWrapper {...congfigAuthWrapper}>
					<h3 className="my-5">Select a service to connect with a vendor</h3>
					<Form  className="mx-auto">
						<div className="payPerService-col">
							{payPerServiceArray.map((product, index) => {
									const {
										productName,
										documentID,
										productDesc
									} = product;
									
									return (

										<div className="row label" key={index}>
											<label className="m-1 label planDetail" htmlFor={documentID}>{productName}
											
												{productDesc &&(
													<span className="planTooltip">{productDesc}</span>
													)		 
												}
											
											
											</label>

										
											<div className="text-right col">
												<button className="add-btn mt-1" onClick={() => history.push(`/customersServicesChat/${productName}`)}>
													Chat
												</button>
											</div>
										</div>
									)
								})}
						</div>
					
						<div className="mt-5">
							<Link to="/dashboard">
								<Button className="btn cancel mx-3">
									CANCEL
								</Button>
							</Link>
							
						</div>	
						
					</Form>

				
				</DashAuthWrapper>
			)}
		</div>
		
	)
}

export default NeededServiceDetails;


